module.exports = __webpack_public_path__ + "img/Common_Tern.9bafd336.png";